import { useMutation } from 'react-query';
import axios from 'axios';

export const useDownloadVideo = () =>
  useMutation(['downloadVideo'], async (videoId) => {
    const signedUrlEndpoint = `/kodak-api/api/v1/media/videos/${videoId}/downloadUrl`;
    const getSignedUrlResponse = await axios.get(signedUrlEndpoint);
    const signedUrl = getSignedUrlResponse?.data?.response;

    const file = await axios({
      url: signedUrl,
      method: 'GET',
      responseType: 'blob',
    });
    return file.data;
  });
